import { ceil } from 'lodash';
import React from 'react';
import { DataForDesignDrawingsManifold } from '../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';
import { PortRow } from './templates/PortRow';

type Props = {
  manifold: DataForDesignDrawingsManifold;
  roundUp?: boolean;
};
export const CutLengthRow = ({ manifold, roundUp = false }: Props) => {
  return (
    <PortRow
      name="Cut Length (m)"
      manifold={manifold}
      getValue={room => (roundUp && room.cutLengthInMetres ? ceil(room.cutLengthInMetres) : room.cutLengthInMetres)}
    />
  );
};
